import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  list: null,
}

export const requestsAction = createSlice({
  name: 'page',
  initialState,
  reducers: {
    setList: (state, action) => {
      state.list = action.payload
    },
  },
})

export const { setList } = requestsAction.actions

export default requestsAction.reducer